<ion-header *ngIf="isInModal">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()" class="close-modal-button">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<!-- avatar -->
<div class="avatar-name-and-vip-toggle">
  <app-avatar [src]="taskProcessContext.from?.avatarURL" class="avatar-thumbnail"></app-avatar>
  <div *ngIf="!isEditingUserName" class="user-name">
    <ion-button *ngIf="!isUserReadOnly && !taskProcessContext.engagement" size="small" fill="clear" class="invisible">
      <ion-icon slot="icon-only" name="pencil-sharp"></ion-icon>
    </ion-button>
    <span>{{
      taskProcessContext.from?.name || ('engagement/send-message/choose-sender-recipient/unknown-user' | translate)
    }}</span>
    <ion-button
      *ngIf="taskProcessContext.from && !isUserReadOnly && !taskProcessContext.engagement"
      (click)="editUserName()"
      size="small"
      fill="clear">
      <ion-icon slot="icon-only" name="pencil-sharp"></ion-icon>
    </ion-button>
  </div>
  <div *ngIf="isEditingUserName" class="user-name-edition">
    <ion-input #nameEditionInput [(ngModel)]="editedName"></ion-input>
    <ion-button (click)="saveUserName()" size="small" fill="clear">
      <ion-icon slot="icon-only" name="save"></ion-icon>
    </ion-button>
    <ion-button (click)="isEditingUserName = false" size="small" fill="clear">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </div>
  <div *ngIf="taskProcessContext.from?.phoneNumber" class="phone-number">
    {{ taskProcessContext.from.phoneNumber }}
  </div>
  <span class="vip-toggle-container">
    <!-- Should not be modified in engagement mode because the update needs a processed task id. -->
    <ion-toggle
      [disabled]="
        taskProcessContext.engagement || !taskProcessContext.from || !hasTagVipCapabilityOnSite || isUserReadOnly
      "
      [checked]="taskProcessContext.from?.isVIP"
      (ionChange)="onVIPChanged($event)"
      color="danger"></ion-toggle>
    <span [class.red]="taskProcessContext.from?.isVIP" class="vip-label">{{ 'm/vip' | translate }} </span>
  </span>
</div>

<!-- site -->
<app-site-icon-and-name
  class="engagement"
  *ngIf="taskProcessContext.engagement; else legacySite"
  [item]="taskProcessContext.site">
  {{ $any(taskProcessContext.site)?.label }}
</app-site-icon-and-name>
<ng-template #legacySite>
  <app-site-icon-and-name [site]="$any(taskProcessContext.site)"></app-site-icon-and-name>
</ng-template>
<!-- user -->
<ng-container *ngIf="user; else unknownUser">
  <div *ngIf="user.external_url">
    <a [href]="user.external_url" target="_blank">{{ user.nameAndHandle }}</a>
  </div>
  <div *ngIf="!user.external_url">{{ user.nameAndHandle }}</div>
  <div *ngIf="user.details.stat" class="stats">
    <ng-container *ngFor="let stat of user.details.stat">
      <div class="stat-count">{{ stat.count }}</div>
      <div class="stat-unit">{{ stat.description }}</div>
    </ng-container>
  </div>
  <table *ngIf="user.details.info" class="infos">
    <tr *ngFor="let info of user.details.info">
      <td>{{ info.description }}:</td>
      <td>{{ info.value }}</td>
    </tr>
  </table>
  <div class="actions" *ngIf="!isUserReadOnly">
    <ion-button
      *ngFor="let action of user.actions_allowed"
      (click)="performUserAction(action.action_type)"
      fill="clear"
      >{{ action.text }}</ion-button
    >
  </div>
</ng-container>

<ng-template #unknownUser>
  <small translate="engagement/send-message/choose-sender-recipient/unknown-user"></small>
</ng-template>

<!-- action buttons -->
<div class="actions" *ngIf="!isUserReadOnly">
  <ion-button
    *ngIf="canOpenProfileDialog"
    (click)="openProfileDialog()"
    fill="clear"
    [disabled]="!user || !user.id || !taskProcessContext.from || !taskProcessContext.from.id"
    >{{ 'm/task-process/profile/see_profile' | translate }}</ion-button
  >
  <ion-button *ngIf="canExportConversation" (click)="exportConversationToExcel()" fill="clear">{{
    'm/task-process/profile/export-to-excel' | translate
  }}</ion-button>
</div>

<!-- CRM -->
<app-crm-organizations-linked
  *ngIf="user"
  [userId]="user.id"
  [taskProcessContext]="taskProcessContext"></app-crm-organizations-linked>

<!-- external tool -->
<ng-container *ngIf="canOpenExternalTool && !isUserReadOnly">
  <div *ngFor="let config of externalToolConfigs" class="link-to-exernal-tool">
    <ion-button *ngIf="config.externalTabUrl; else iFrame" [href]="config.externalTabUrl" target="_blank">{{
      config.buttonLabel
    }}</ion-button>
    <ng-template #iFrame>
      <ion-button (click)="openExternalToolModal(config)" fill="clear">{{ config.buttonLabel }}</ion-button>
    </ng-template>
  </div>
</ng-container>
